import { IConsumerCreateRequest } from "./IConsumerCreateRequest";
import { ISubscriptionCreateRequest } from "./ISubscriptionCreateRequest";

export type ProvisionStatus = "pending" | "loading" | "success" | "error";

export interface ISubscriptionDraft extends ISubscriptionCreateRequest {
  /** Unique client-side ID for tracking during draft phase */
  draftId: string;
  /** When true, events array should be [] (no filter = all events including future) */
  useAllEvents: boolean;
  /** Status during provisioning */
  provisionStatus: ProvisionStatus;
  /** Error message if provisioning failed */
  errorMessage?: string;
  /** Server-assigned ID after successful creation */
  createdSubscriptionId?: string;
}

export interface IProvisionableConsumer extends IConsumerCreateRequest {
  /** Status during provisioning */
  provisionStatus: ProvisionStatus;
  /** Error message if provisioning failed */
  errorMessage?: string;
  /** Server-assigned ID after successful creation */
  createdConsumerId?: string;
}

export interface IProvisioningState {
  consumer: IProvisionableConsumer;
  subscriptions: ISubscriptionDraft[];
  /** Overall provisioning phase */
  phase: "configuring" | "provisioning" | "completed" | "error";
  /** Index of currently provisioning subscription (-1 for consumer, -2 for not started) */
  currentProvisioningIndex: number;
}

/** Create an empty subscription draft with defaults */
export const createEmptySubscriptionDraft = (): ISubscriptionDraft => ({
  draftId: crypto.randomUUID(),
  producerId: "",
  status: "Active",
  accountIdFilter: undefined,
  iTwinIdFilter: undefined,
  resourceDataCenterIdFilter: undefined,
  iTwinDataCenterIdFilter: undefined,
  events: [],
  useAllEvents: true,
  provisionStatus: "pending",
});

/** Create an empty consumer with defaults */
export const createEmptyProvisionableConsumer = (): IProvisionableConsumer => ({
  maintainerIds: [],
  description: "",
  serviceGPRId: 0,
  status: "Active",
  provisionStatus: "pending",
});
